import { Link } from 'react-router-dom';
import { ChevronRightIcon, HomeIcon } from '@heroicons/react/24/outline';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <nav className="flex items-center space-x-2 text-sm mb-4">
      <Link 
        to="/dashboard"
        className="text-gray-500 hover:text-golf-600 dark:text-gray-400 dark:hover:text-golf-400 transition-colors"
      >
        <HomeIcon className="h-4 w-4" />
      </Link>
      
      {items.map((item, index) => (
        <div key={index} className="flex items-center">
          <ChevronRightIcon className="h-4 w-4 text-gray-400 dark:text-gray-600 mx-1" />
          {item.href && index < items.length - 1 ? (
            <Link 
              to={item.href}
              className="text-gray-500 hover:text-golf-600 dark:text-gray-400 dark:hover:text-golf-400 transition-colors"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-gray-700 dark:text-gray-300 font-medium">
              {item.label}
            </span>
          )}
        </div>
      ))}
    </nav>
  );
}